import React, { Component } from 'react';
import { connect } from 'react-redux';
import { GeckoLoadingService, GeckoToastService } from '../../ui';
import GeckoLocation from 'services/gecko-location';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import GeckoStore from 'services/gecko-store';

class DynamicsOAuth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      failed: false,
      loading: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.current_user) return;

    const newDynamicsIntegration = {
      account_id: nextProps.current_user.account_id,
      configuration: {
        // get Dynamics setup details from sessionStorage, Dynamics auth code from params
        authCode: GeckoLocation.params.code,
        client_id: GeckoStore.localStorage.get('dynamics_client_id'),
        client_secret: GeckoStore.localStorage.get('dynamics_client_secret'),
        resource: GeckoStore.localStorage.get('dynamics_resource'),
        chosen_module: GeckoStore.localStorage.get('dynamics_chosen_module'),
      },
      type: 'dynamics',
    };

    let failed = false;
    // if (!newDynamicsIntegration) failed = true;
    if (!newDynamicsIntegration.account_id) failed = true;
    if (!newDynamicsIntegration.configuration.authCode) failed = true;
    if (this.state.loading) return;

    if (failed) {
      return this.setState({ failed });
    }

    this.setState({ loading: true });

    const saveIntegration = GeckoRequest.post(
      '/integration/',
      newDynamicsIntegration
    );
    new GeckoLoadingService()
      .resolve(saveIntegration)
      .then((integration) => {
        new GeckoToastService().success(`Dynamics integration created`);
        return GeckoLocation.goTo(`/settings/integration/dynamics`);
      })
      .catch(renderError);
  }

  render() {
    if (this.state.failed) {
      return (
        <div>
          <h2>ಠ_ಠ Oops something went wrong!</h2>
          <a href="/#/settings/integrations">Back</a>
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    current_user: state.appState.loggedInUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(DynamicsOAuth);
